import Vue from "vue";

export const challengesService = {
  list,
  getById,
  getRatingById,
  create,
  update,
  deleteChallenge,
  finishChallenge
};

function list(params) {
  return Vue.axios.get("v2/admin/challenges", { params });
}

function getById(id) {
  return Vue.axios.get(`v2/admin/challenges/${id}`);
}

function getRatingById(id) {
  return Vue.axios.get(`v2/admin/challenges/${id}/podium`);
}

function create(payload) {
  const formData = new FormData();

  formData.set("title", payload.title);
  formData.set("description", payload.description);
  formData.set("goal", payload.goal);
  formData.set("winners_limit", payload.winners_limit);
  formData.set("status", payload.status);
  formData.set("reward", payload.reward);
  // formData.set("start_date", payload.start_date);
  formData.set("end_date", payload.end_date);

  payload.event_ids.forEach(id => {
    formData.append("event_ids[]", id);
  });

  payload.team_ids.forEach(id => {
    formData.append("team_ids[]", id);
  });

  return Vue.axios.post("v2/admin/challenges", formData);
}

function update(payload) {
  const formData = new FormData();

  formData.set("title", payload.title);
  formData.set("description", payload.description);
  formData.set("goal", payload.goal);
  formData.set("winners_limit", payload.winners_limit);
  formData.set("reward", payload.reward);
  formData.set("status", payload.status);
  // formData.set("start_date", payload.start_date);
  formData.set("end_date", payload.end_date);

  payload.event_ids.forEach(id => {
    formData.append("event_ids[]", id);
  });

  payload.team_ids.forEach(id => {
    formData.append("team_ids[]", id);
  });

  return Vue.axios.patch(`v2/admin/challenges/${payload.id}`, formData);
}

function deleteChallenge(id) {
  return Vue.axios.delete(`v2/admin/challenges/${id}`);
}

function finishChallenge(id) {
  return Vue.axios.post(`v2/admin/challenges/${id}/finish`);
}
